import { Subject } from "rxjs";

import { Injectable } from "@angular/core";

import { ChartFilterType, IFilter, MalfunctionDateChangeType, MalfunctionFilterType } from "../helpers/types";

@Injectable()
export class MessageService {
  private readonly enableFilterSource = new Subject<IFilter>();
  private readonly enableMalfunctionFilterSource = new Subject<MalfunctionFilterType>();
  private readonly disableFilterSource = new Subject<IFilter>();
  private readonly malfunctionFilterDateSource = new Subject<MalfunctionDateChangeType>();
  private readonly malfunctionLoadMoreSource = new Subject<void>();
  private readonly chartFilterSource = new Subject<ChartFilterType>();
  private readonly selfServiceMessageSource = new Subject<string>();

  readonly enableFilter$ = this.enableFilterSource.asObservable();
  readonly enableMalfunctionFilter$ = this.enableMalfunctionFilterSource.asObservable();
  readonly disableFilter$ = this.disableFilterSource.asObservable();
  readonly malfunctionFilterDate$ = this.malfunctionFilterDateSource.asObservable();
  readonly malfunctionLoadMore$ = this.malfunctionLoadMoreSource.asObservable();
  readonly chartFilter$ = this.chartFilterSource.asObservable();
  readonly selfServiceMessage$ = this.selfServiceMessageSource.asObservable();

  enableFilter(data: IFilter) {
    this.enableFilterSource.next(data);
  }

  disableFilter(data: IFilter) {
    this.disableFilterSource.next(data);
  }

  setChartFilter(data: ChartFilterType) {
    this.chartFilterSource.next(data);
  }

  enableMalfunctionFilter(data: MalfunctionFilterType) {
    this.enableMalfunctionFilterSource.next(data);
  }

  setMalfunctionFilterDate(data: MalfunctionDateChangeType) {
    this.malfunctionFilterDateSource.next(data);
  }

  setMalfunctionLoadMore() {
    this.malfunctionLoadMoreSource.next();
  }

  setSelfServiceMessage(data: string) {
    this.selfServiceMessageSource.next(data);
  }
}
